module.exports = __webpack_public_path__ + "img/P150T_weapon_24.cf8f992e.png";